// -----------------------------------------------------------------------------
// MapLibre zoom ceiling
// -----------------------------------------------------------------------------
// MapLibre GL JS validates layer `minzoom`/`maxzoom` against the style spec range
// 0–24 and throws when a layer exceeds it:
//
//   Error: layers.Drone Map: …maxzoom: 25 is greater than the maximum value 24
//
// That error was observed on the Bardi site, where a drone-ortho config layer
// advertises 25. A thrown layer can break the whole map, so a bad org config or
// stale worker metadata must never reach MapLibre unclamped.
//
// Note this is a *different* ceiling from the worker's: GDAL MBTiles / gdaladdo
// top out at 22. That one is the pipeline's problem; 24 is the client's.
// -----------------------------------------------------------------------------

/** Highest layer zoom the MapLibre style spec accepts. */
export const MAPLIBRE_MAX_ZOOM = 24;

/**
 * Clamps a configured zoom into MapLibre's 0–24 range.
 *
 * Returns {@link MAPLIBRE_MAX_ZOOM} when the value is absent or not a finite
 * number, so callers can drop the `?? 24` fallbacks they used to carry.
 */
export const clampMaxZoom = (value?: number | null): number => {
  if (typeof value !== "number" || !Number.isFinite(value)) return MAPLIBRE_MAX_ZOOM;
  return Math.min(MAPLIBRE_MAX_ZOOM, Math.max(0, value));
};
